import { Component, Input, OnInit } from '@angular/core';
import { pickBy } from 'lodash';
import { AuthService } from 'src/app/_services/auth.service';
import { CompanyService } from 'src/app/_services/company.service';
import { FilesControlService } from 'src/app/_services/files-control.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
})
export class HistoryComponent implements OnInit {
  operations: [] = [];
  users: [] = [];

  selectedOperations;
  selectedUsers;

  tableData: any = [];
  page = 1;
  pageSize = 5;
  collectionSize = 0;

  isLoading;
  filters;

  @Input() id;

  constructor(
    public filesControlService: FilesControlService,
    public companyService: CompanyService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    this.isLoading = true;
    this.filesControlService
      .getFileHistoryById(
        this.page,
        { ...this.filters, id: this.id },
        this.pageSize
      )
      .subscribe((res) => {
        this.collectionSize = res.body['total'];
        this.tableData = res.body['results'];
        this.page = res.body['page'];
        this.isLoading = false;
      });
  }

  setFilters() {
    const filters = {
      operation:
        this.selectedOperations?.length > 1
          ? [this.selectedOperations]
          : this.selectedOperations,
      user:
        this.selectedUsers?.length > 1
          ? [this.selectedUsers]
          : this.selectedUsers,
    };
    this.filters = {
      ...filters,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshData();
  }

  cleanFilters() {
    this.selectedOperations = undefined;
    this.selectedUsers = undefined;
    this.filters = undefined;
    this.filters = {
      ...this.filters,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshData();
  }

  formatDateTable(date): string {
    const fecha = new Date(date);

    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    const horas = fecha.getHours();
    const minutos = fecha.getMinutes();
    const segundos = fecha.getSeconds();

    return `${this.complete(dia)}/${this.complete(
      mes
    )}/${anio}, ${this.complete(horas)}:${this.complete(
      minutos
    )}:${this.complete(segundos)}`;
  }

  complete(numero) {
    return numero < 10 ? `0${numero}` : numero;
  }
}
